import React, { useEffect, useState } from 'react';
import {
  UserOutlined,
  MenuUnfoldOutlined,
  WalletOutlined,
  ShoppingCartOutlined,
  FileTextOutlined,
  ProductOutlined,
  GiftOutlined,
  HeartOutlined,
  GatewayOutlined,
  AuditOutlined,
  SettingOutlined,
  TagOutlined,
  GroupOutlined,
  PayCircleOutlined,
  PrinterOutlined,
  HomeOutlined,
  UsergroupAddOutlined,
  HddOutlined,
  BarChartOutlined

} from '@ant-design/icons';
import { Button, Layout, Menu, theme } from 'antd';
import PageRoutes from "./PageRoutes"
import { BrowserRouter, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "contexts/auth"

const { Header, Sider, Content } = Layout;

const allMenu = [
  {
    key: '/dashboard',
    icon: <HomeOutlined />,
    label: 'Tổng quan',
    permission: "",
  },
  {
    key: '/workspace',
    icon: <FileTextOutlined />,
    label: 'Shop',
    permission: "order.all",
  },
  





]

const AppMenu = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [menuItems, setMenuItems] = useState([])
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {

    var items = [...allMenu];
    setMenuItems(items);

  }, [user])

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  const menuClick = (e) => {

    navigate(e.key);
  }

  return (

    <Menu
      theme="dark"
      mode="inline"
      onClick={menuClick}
      defaultSelectedKeys={['']}
      items={menuItems}
    />

  );
};

export default AppMenu;